import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { events } from '../../helpers';
import { getPipeMessage } from '../../selectors/events';

interface PipeMessage {
  name: string;
  callback?: () => void;
}

interface ChatConfig {
  visible: boolean;
  callback: (() => void) | null;
}

const getChatConfig = (
  pipeMessage: PipeMessage | null,
  currentState: ChatConfig | null = null,
): ChatConfig => {
  if (
    pipeMessage &&
    pipeMessage.name === 'enable-chat' &&
    typeof pipeMessage.callback === 'function'
  ) {
    return { visible: true, callback: pipeMessage.callback };
  }
  if (pipeMessage && pipeMessage.name === 'disable-chat') {
    return { visible: false, callback: null };
  }

  return currentState || { visible: false, callback: null };
};

interface ContactMessageProps {
  isLight?: boolean;
}

const ContactMessage = ({ isLight }: ContactMessageProps) => {
  const pipeMessage = useSelector(getPipeMessage) as unknown as PipeMessage | null;
  const { t } = useTranslation('item');
  const [state, setState] = useState<ChatConfig>({ ...getChatConfig(pipeMessage) });

  useEffect(() => {
    setState({ ...getChatConfig(pipeMessage, state) });
  }, [pipeMessage]);

  const { visible, callback } = state;

  if (!visible) {
    return null;
  }

  return (
    <button
      type="button"
      data-wx-button={`${isLight ? 'action-light' : 'action'} full-width`}
      title={t('Chat', { ns: 'item' })}
      onClick={events.silencer(callback)}
    >
      <i className="icon-message m-r-half" />
      {t('Chat', { ns: 'item' })}
    </button>
  );
};

export default ContactMessage;
